import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import '../components/servicebox.css';

function Servicesbox() {
  const [serdta, setServdata] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const servicedata = async () => {
      try {
        const result = await fetch('https://backend.corporateeventplanner.in/api/cyj-service');
        const data = await result.json();
        setServdata(data);
      } catch (error) {
        console.log(error);
      }
    };
    servicedata();
  }, []);

  return (
    <div className='service-always'>
      {/* Toggle Button with Swiper inside */}
      <div className='service-toggle-btn' onClick={() => setIsOpen(!isOpen)}>
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          loop="true"
          autoplay={{ delay: 3000 }}
          modules={[Autoplay]}
          className='service-swiper-btn'
        >
          {serdta
            .filter(serv => serv.status === 1)
            .slice(0, 8)
            .map((serv, index) =>
              serv.image
                .filter(i => i.service_banner)
                .map((i, imgIndex) => (
                  <SwiperSlide key={`${index}-${imgIndex}`}>
                    <div
                      className='service-slide-btn'
                      style={{
                        backgroundImage: `url(https://backend.corporateeventplanner.in/storage/service_gallery/${i.service_banner})`,
                      }}
                    >
                      <span className='service-name-btn'>{serv.service}</span>
                    </div>
                  </SwiperSlide>
                ))
            )}
        </Swiper>
      </div>

      {/* Popup for Services */}
      {isOpen && (
        <div className='service-name-popup'>
          <span className='close-btn' onClick={() => setIsOpen(false)}>
            &times;
          </span>

          <div className='service-name-list'>
            {serdta
              .filter((serv) => serv.status === 1)
              .map((serv, index) => (
                <a
                  href={serv.service_url}
                  key={index}
                  className='service-name-item'
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  {serv.service}
                </a>
              ))}
          </div>
        </div>
      )}

      {/* Fixed Marquee at Bottom */}
      <div className='service-marquee'>
        <div className='marquee-content'>
        🌍 <strong>Delivering Exceptional Corporate Event Solutions</strong> – From <strong>Corporate Events</strong>, <strong>Conferences & Seminars</strong>, and <strong>Executive Retreats & Incentive Programs</strong> to <strong>Corporate Parties</strong>, <strong>Product Launches</strong>, <strong>Festive Celebrations</strong>, <strong>Exhibitions & Trade Shows</strong>, and <strong>Business Meetups</strong> – We Plan & Execute at <strong>All Locations: Pan India & Internationally</strong>.
        </div>
       
      </div>
    </div>
  );
}

export default Servicesbox;
